module.exports = __webpack_public_path__ + "img/DigitalPlus.e3115657.jpg";